export class UpdateLicenseDataModel {
  have_licence: boolean | null = null
  licence_number: string | null = ''
  have_licence_at: string | null = ''
}
